import { render, staticRenderFns } from "./DriversCard.vue?vue&type=template&id=11ca248f&scoped=true&"
import script from "./DriversCard.vue?vue&type=script&lang=js&"
export * from "./DriversCard.vue?vue&type=script&lang=js&"
import style0 from "./DriversCard.vue?vue&type=style&index=0&id=11ca248f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca248f",
  null
  
)

export default component.exports